import { useState } from 'react';
import img1 from './Image/marketing-sample1.png'
import img2 from './Image/marketing-sample2.png'
import img3 from './Image/marketing-sample3.png'
import './index.css';

const data = [
    {
        picture: img1,
        aspectRatio: '1:1',
    },
    {
        picture: img2,
        aspectRatio: '16:9',
    },
    {
        picture: img3,
        aspectRatio: '9:16',
    },

]

const ContentMarketingPoster = () => {
    const [selectedImage, setSelectedImage] = useState(null);

    return (
        <div className='text-white'>
            {
                data.map((item, index) => <div className='mb-5' key={index}>
                    <p className='text-center'><span className='fw-bold'>Aspect Ratio:</span> {item.aspectRatio}</p>
                    <img
                        className='imgeAI-image mx-auto d-block'
                        src={item.picture}
                        alt={item.topic}
                        onClick={(e) => {
                            e.stopPropagation();
                            setSelectedImage(item.picture);
                        }}
                        style={{
                            cursor: "pointer",
                            transition: "transform 0.2s",
                        }}
                        onMouseEnter={(e) => e.target.style.transform = "scale(1.02)"}
                        onMouseLeave={(e) => e.target.style.transform = "scale(1)"}
                    />
                </div>)
            }

            {/* Lightbox Modal */}
            {selectedImage && (
                <div
                    style={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        width: "100vw",
                        height: "100vh",
                        background: "rgba(0,0,0,0.85)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        zIndex: 9999,
                        cursor: "pointer",
                    }}
                    onClick={() => setSelectedImage(null)}
                >
                    <img
                        src={selectedImage}
                        alt="Preview"
                        style={{
                            maxWidth: "90vw",
                            maxHeight: "90vh",
                            borderRadius: "12px",
                            boxShadow: "0 10px 40px rgba(0,0,0,0.5)",
                        }}
                        onClick={(e) => e.stopPropagation()}
                    />
                    <div
                        style={{
                            position: "absolute",
                            top: "20px",
                            right: "30px",
                            color: "#fff",
                            fontSize: "30px",
                            cursor: "pointer",
                        }}
                        onClick={() => setSelectedImage(null)}
                    >
                        ✕
                    </div>
                </div>
            )}
        </div>
    );
};

export default ContentMarketingPoster;